export const GENERIC_ERROR_MESSAGE =
  'Something went wrong while trying to create this stage. Please try again or contact an administrator.';
export const GENERIC_UPDATE_MESSAGE = 'Your changes have been saved.';
export const GENERIC_UPDATE_ERROR_MESSAGE =
  'Something went wrong while trying to update this stage. Please try again or contact an administrator.';
export const ADD_NEW_STAGE_FORM_HEADER_TEXT = `Creating a stage from an existing object will copy existing data from that item when relevant. These
items include: Customer, Locations, Shipping Items, Reference Numbers, Tags, Instructions.`;
export const CLONE_STAGE_FORM_HEADER_TEXT =
  'Cloning a stage will copy all existing data besides container number, seal number, and chassis number to the new stage.';
